import { useQuery } from '@tanstack/react-query';
import { CheckCircle2 } from 'lucide-react';
import { apiClient } from '@/lib/api-client';
import { CardShell } from '../cards/card-shell';

/**
 * Conta clientes que tem ao menos um processo ativo. Backend (D02)
 * resolve via JOIN case_parties + cases.status='active'.
 */
export function SummaryWithProcessWidget() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['clients', 'stats', 'summary'],
    queryFn: () => apiClient.clientsStatsSummary(),
    staleTime: 1000 * 60,
  });

  return (
    <CardShell title="Com processo ativo" icon={CheckCircle2}>
      <div className="flex w-full flex-col items-start gap-2">
        {isLoading ? (
          <div className="h-10 w-20 animate-pulse rounded bg-[var(--surface-muted)]" />
        ) : isError ? (
          <p className="text-xs text-[var(--fg-muted)]">
            Não foi possível carregar.
          </p>
        ) : (
          <>
            <span className="text-3xl font-semibold tracking-tight text-[var(--fg)]">
              {data?.withActiveProcess ?? 0}
            </span>
            <p className="text-[11px] text-[var(--fg-muted)]">
              Clientes com pelo menos um processo ativo.
            </p>
          </>
        )}
      </div>
    </CardShell>
  );
}
